export const TRUNCATE_MIDDLE_MAX_LENGTH = 30;

export function truncateMiddle(
    text: string,
    maxLength: number = TRUNCATE_MIDDLE_MAX_LENGTH,
) {
    if (text.length <= maxLength) return text;

    const charsToShow = maxLength - 3; // 3 for ellipsis
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);

    return (
        text.substring(0, frontChars) +
        "…" +
        text.substring(text.length - backChars)
    );
}
